<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="90px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="工厂名称">
                  <el-input style='width: 177px;' v-model="queryForm.factoryName"></el-input>
              </el-form-item>
              <el-form-item label="联系人姓名">
                  <el-input style='width: 177px;' v-model="queryForm.contactPerson"></el-input>
              </el-form-item>
              <el-form-item label="联系人电话">
                  <el-input style='width: 177px;' v-model="queryForm.contactPhone"></el-input>
              </el-form-item>
              <el-form-item label="工厂管理">
<!--                  <el-input style='width: 177px;' v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择管理员" labelName="userName"
                               labelValue="id" :value="queryForm.userId" :limit='1' size='small'
                               placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search"
                               dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                               queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getWashcloudFactoryList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addWashcloudFactory"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editWashcloudFactory(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteWashcloudFactory(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshWashcloudFactoryList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="washcloudFactoryList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="factoryName"
        label="工厂名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="factoryLogo"
        label="工厂LOGO"
        width="180"
      >
          <template slot-scope="scope">
              <el-image @click='updateSrcList(scope.row.factoryLogo)' style="width: 60px; height: 60px"
                        :src="scope.row.factoryLogo" :preview-src-list="srcList"></el-image>
          </template>
      </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="provinceId"-->
<!--        label="省"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="cityId"-->
<!--        label="市"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="areaId"-->
<!--        label="区"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="factoryAddress"
        label="详细地址"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if='scope.row.factoryAddress'>
                  <div style="text-align: left;">区域:{{ scope.row.province.areaName
                      }}{{ scope.row.city.areaName }}{{ scope.row.area.areaName }}
                  </div>
                  <div style="text-align: left;overflow:hidden;text-overflow: ellipsis;">
                      详细地址:{{ scope.row.factoryAddress }}
                  </div>
              </div>

              <div v-else>--</div>
          </template>
      </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="factoryPosition"-->
<!--        label="定位"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="longitude"-->
<!--        label="经度"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="latitude"-->
<!--        label="纬度"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="openHours"
        label="营业时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="contactPerson"
        label="联系人"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.contactPerson">
                  <div style="text-align: left">联系姓名:{{ scope.row.contactPerson }}</div>
                  <div style="text-align: left">联系电话:{{ scope.row.contactPhone }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="contactPhone"-->
<!--        label="联系人电话"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="remarks"
        label="备注"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="工厂管理"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="maxClothes"
        label="最大衣服洗护量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="maxShoe"
        label="最大鞋子洗护量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="maxLeather"
        label="最大皮革护理量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="maxRepair"
        label="最大衣鞋改补量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkWashcloudFactory(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editWashcloudFactory(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteWashcloudFactory(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="washcloudFactoryStates[washcloudFactoryState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="washcloudFactory"
          ref="washcloudFactoryForm"
          :rules="rules"
          label-width="130px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="工厂名称"
            prop="factoryName"
          >
            <el-input
              size="small"
              style='width: 177px;'
              v-model="washcloudFactory.factoryName"
              :disabled="washcloudFactoryState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="工厂LOGO"
            prop="factoryLogo"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style='width: 177px;'-->
<!--              v-model="washcloudFactory.factoryLogo"-->
<!--              :disabled="washcloudFactoryState == 'check'"-->
<!--            ></el-input>-->
              <div style="width: 177px;display: flex;align-items: center;">
                  <el-input v-model="washcloudFactory.factoryLogo" size="small" :disabled="washcloudFactoryState == 'check'"></el-input>
                  <el-button type="primary" :disabled="washcloudFactoryState == 'check'" size="small" style="margin-left: 2px;" @click="uploadImages()">上传图片
                      <el-upload action="" v-show="false" ref="uploads" class="avatar-uploader" :show-file-list="false"
                                 :http-request="uploadAvatar">
                          <el-button type="primary" size="small" class="as">上传</el-button>
                      </el-upload>
                  </el-button>
              </div>
          </el-form-item>
            <el-form-item label="工厂位置" prop="factoryAddress">
                <location
                    style='width: 177px;'
                    :areaTreeDate="areaTreeDate"
                    :longitude="washcloudFactory.factoryPosition.split(',')[0]"
                    :latitude="washcloudFactory.factoryPosition.split(',')[1]"
                    :provinceId="washcloudFactory.provinceId"
                    :cityId="washcloudFactory.cityId"
                    :areaId="washcloudFactory.areaId"
                    :address="washcloudFactory.factoryAddress"
                    :disabled="washcloudFactoryState == 'check'"
                    @getLocation="getLocation"
                ></location>
            </el-form-item>
          <el-form-item
            label="所属省份"
            prop="provinceId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="washcloudFactory.provinceId"-->
<!--              :disabled="washcloudFactoryState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  placeholder='请选择省'
                  @change="clearSubitem('province')"
                  clearable
                  style='width: 177px'
                  size='small'
                  v-model='washcloudFactory.provinceId'
                  :disabled="washcloudFactoryState == 'check'"
              >
                  <el-option
                      v-for='(item,index) in provinceArry'
                      :key='index'
                      :label='item.areaName'
                      :value='item.id'
                  >
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="所属城市"
            prop="cityId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="washcloudFactory.cityId"-->
<!--              :disabled="washcloudFactoryState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  placeholder='请选择市'
                  @change="clearSubitem('city')"
                  clearable
                  style='width: 177px'
                  size='small'
                  v-model='washcloudFactory.cityId'
                  :disabled="washcloudFactoryState == 'check'"
              >
                  <el-option
                      v-for='(item,index) in cityArry'
                      :key='index'
                      :label='item.areaName'
                      :value='item.id'
                  >
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="所属区县"
            prop="areaId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="washcloudFactory.areaId"-->
<!--              :disabled="washcloudFactoryState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  placeholder='请选择区县'
                  clearable
                  style='width: 177px'
                  size='small'
                  v-model='washcloudFactory.areaId'
                  :disabled="washcloudFactoryState == 'check'"
              >
                  <el-option
                      v-for='(item,index) in areaArry'
                      :key='index'
                      :label='item.areaName'
                      :value='item.id'
                  >
                  </el-option>
              </el-select>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="详细地址"-->
<!--            prop="factoryAddress"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="washcloudFactory.factoryAddress"-->
<!--              :disabled="washcloudFactoryState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="工厂定位"
            prop="factoryPosition"
          >
            <el-input
              size="small"
              style='width: 177px;'
              v-model="washcloudFactory.factoryPosition"
              :disabled="washcloudFactoryState == 'check'"
            ></el-input>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="经度"-->
<!--            prop="longitude"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style='width: 177px;'-->
<!--              v-model="washcloudFactory.longitude"-->
<!--              :disabled="washcloudFactoryState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="纬度"-->
<!--            prop="latitude"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style='width: 177px;'-->
<!--              v-model="washcloudFactory.latitude"-->
<!--              :disabled="washcloudFactoryState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="营业时间"
            prop="openHours"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="washcloudFactory.openHours"-->
<!--              :disabled="washcloudFactoryState == 'check'"-->
<!--            ></el-input>-->
              <el-time-picker
                  :disabled="washcloudFactoryState == 'check'"
                  is-range
                  style="width: 177px;"
                  v-model="washcloudFactory.openHours"
                  range-separator="至"
                  format='HH:mm:ss'
                  value-format='HH:mm:ss'
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围">
              </el-time-picker>
          </el-form-item>
          <el-form-item
            label="联系人姓名"
            prop="contactPerson"
          >
            <el-input
              size="small"
              style='width: 177px;'
              v-model="washcloudFactory.contactPerson"
              :disabled="washcloudFactoryState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系人电话"
            prop="contactPhone"
          >
            <el-input
              size="small"
              style='width: 177px;'
              v-model="washcloudFactory.contactPhone"
              :disabled="washcloudFactoryState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="工厂备注"
            prop="remarks"
          >
            <el-input
              size="small"
              style='width: 177px;'
              v-model="washcloudFactory.remarks"
              :disabled="washcloudFactoryState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="工厂管理"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style='width: 177px;'-->
<!--              v-model="washcloudFactory.userId"-->
<!--              :disabled="washcloudFactoryState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择管理员" labelName="userName"
                           :disabled="washcloudFactoryState == 'check'"
                           labelValue="id" :value="washcloudFactory.userId" :limit='1' size='small'
                           placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search"
                           dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                           queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="最大衣服洗护量"
            prop="maxClothes"
          >
            <el-input
              size="small"
              style='width: 177px;'
              v-model="washcloudFactory.maxClothes"
              :disabled="washcloudFactoryState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="最大鞋子洗护量"
            prop="maxShoe"
          >
            <el-input
              size="small"
              style='width: 177px;'
              v-model="washcloudFactory.maxShoe"
              :disabled="washcloudFactoryState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="最大皮革护理量"
            prop="maxLeather"
          >
            <el-input
              size="small"
              style='width: 177px;'
              v-model="washcloudFactory.maxLeather"
              :disabled="washcloudFactoryState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="最大衣鞋改补量"
            prop="maxRepair"
          >
            <el-input
              size="small"
              style='width: 177px;'
              v-model="washcloudFactory.maxRepair"
              :disabled="washcloudFactoryState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="washcloudFactoryState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import Location from '@/components/location/location.vue';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Location,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    computed: {
        provinceArry() {
            return this.areaTreeDate;
        },
        cityArry() {
            if (!this.provinceArry) {
                return [];
            } else {
                for (let i = 0; i < this.provinceArry.length; i++) {
                    if (this.provinceArry[i].id == this.washcloudFactory.provinceId) {
                        return this.provinceArry[i].children;
                    } else if (this.washcloudFactory.provinceId == '') {
                        return [];
                    }
                }
            }
        },
        areaArry() {
            if (!this.cityArry) {
                return [];
            } else {
                for (let i = 0; i < this.cityArry.length; i++) {
                    if (this.cityArry[i].id == this.washcloudFactory.cityId) {
                        return this.cityArry[i].children;
                    }
                }
            }
        }
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetWashcloudFactoryList();
                    this.getWashcloudFactoryList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetWashcloudFactoryList();
                    this.getWashcloudFactoryList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     factoryName: '', //工厂名称
                     factoryLogo: '', //工厂LOGO
                     provinceId: '', //省
                     cityId: '', //市
                     areaId: '', //区
                     factoryAddress: '', //详细地址
                     factoryPosition: '', //定位
                     longitude: '', //经度
                     latitude: '', //纬度
                     openHours: '', //营业时间
                     contactPerson: '', //联系人姓名
                     contactPhone: '', //联系人电话
                     remarks: '', //备注
                     userId: '', //工厂管理
                     maxClothes: '', //最大衣服洗护量
                     maxShoe: '', //最大鞋子洗护量
                     maxLeather: '', //最大皮革护理量
                     maxRepair: '', //最大衣鞋改补量
                },
                srcList: [''],
                USER_code: USER,
                USER_search: USER_SEARCH,
                areaTreeDate: [],

                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                washcloudFactoryState: 'add',
                washcloudFactoryStates: {
                    add: '增加工厂',
                    check: '查看工厂',
                    edit: '修改工厂'
                },

                multipleSelection: [],
                washcloudFactoryList: [],
                washcloudFactory: {
                    id: '', //
                    factoryName: '', //工厂名称
                    factoryLogo: '', //工厂LOGO
                    provinceId: '', //省
                    cityId: '', //市
                    areaId: '', //区
                    factoryAddress: '', //详细地址
                    factoryPosition: '', //定位
                    longitude: '', //经度
                    latitude: '', //纬度
                    openHours: ['08:00:00', '20:00:00'], //营业时间
                    contactPerson: '', //联系人姓名
                    contactPhone: '', //联系人电话
                    remarks: '', //备注
                    userId: '', //工厂管理
                    maxClothes: '', //最大衣服洗护量
                    maxShoe: '', //最大鞋子洗护量
                    maxLeather: '', //最大皮革护理量
                    maxRepair: '', //最大衣鞋改补量
                },
                btnLoading: false,

                rules: {
                    factoryName: [{ required: true, message: '工厂名称不能为空', trigger: 'blur' }],
                    factoryLogo: [{ required: true, message: '工厂LOGO不能为空', trigger: 'blur' }],
                    provinceId: [{ required: true, message: '省不能为空', trigger: 'blur' }],
                    cityId: [{ required: true, message: '市不能为空', trigger: 'blur' }],
                    areaId: [{ required: true, message: '区不能为空', trigger: 'blur' }],
                    factoryAddress: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
                    factoryPosition: [{ required: true, message: '定位不能为空', trigger: 'blur' }],
                    longitude: [{ required: true, message: '经度不能为空', trigger: 'blur' }],
                    latitude: [{ required: true, message: '纬度不能为空', trigger: 'blur' }],
                    openHours: [{ required: true, message: '营业时间不能为空', trigger: 'blur' }],
                    contactPerson: [{ required: true, message: '联系人姓名不能为空', trigger: 'blur' }],
                    contactPhone: [{ required: true, message: '联系人电话不能为空', trigger: 'blur' }],
                    remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '工厂管理不能为空', trigger: 'blur' }],
                    maxClothes: [{ required: true, message: '最大衣服洗护量不能为空', trigger: 'blur' }],
                    maxShoe: [{ required: true, message: '最大鞋子洗护量不能为空', trigger: 'blur' }],
                    maxLeather: [{ required: true, message: '最大皮革护理量不能为空', trigger: 'blur' }],
                    maxRepair: [{ required: true, message: '最大衣鞋改补量不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getWashcloudFactoryList();
            this.getTreeData();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            uploadImages(){
                this.$refs.uploads.$el.querySelector(".as").click()
            },
            // 大图预览
            updateSrcList(src) {
                this.srcList[0] = src;
            },
            uploadAvatar(params) {
                console.log({ params });
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg'];
                if (!types.includes(file.type)) {
                    this.$message({
                        message: '只能上传图片格式的文件，png.jpg或者jpeg',
                        type: 'error',
                        showClose: true,
                        duration: 2000
                    });
                    return;
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(`/mpp/image/upload`, formData).then((res) => {
                    console.log({ res });
                    if (res.success) {
                        this.washcloudFactory.factoryLogo = res.url;
                    }
                });
            },
            getValueUser(value) {
                this.washcloudFactory.userId = value;
            },
            getSearchValueUser(value) {
                this.queryForm.userId = value;
            },
            getLocation(location) {
                this.washcloudFactory.factoryPosition = `${location.lng},${location.lat}`;
                this.washcloudFactory.factoryAddress = location.address;
                this.washcloudFactory.provinceId = location.province;
                this.washcloudFactory.cityId = location.city;
                this.washcloudFactory.areaId = location.area;
                this.washcloudFactory.longitude = location.lng;
                this.washcloudFactory.latitude = location.lat;
            },
            clearSubitem(id) {
                if (id == 'province') {
                    this.washcloudFactory.cityId = '';
                    this.washcloudFactory.areaId = '';
                } else if (id == 'city') {
                    this.washcloudFactory.areaId = '';
                }
            },
            getTreeData() {
                get('/mpp/area/treeData').then((res) => {
                    if (res.success) {
                        this.areaTreeDate = res.treeData[0].children;
                    }
                });
            },
            resetWashcloudFactoryList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.washcloudFactoryList = [];
            },
            resetDialog() {
                this.washcloudFactoryState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      factoryName: '', //工厂名称
                      factoryLogo: '', //工厂LOGO
                      provinceId: '', //省
                      cityId: '', //市
                      areaId: '', //区
                      factoryAddress: '', //详细地址
                      factoryPosition: '', //定位
                      longitude: '', //经度
                      latitude: '', //纬度
                      openHours: '', //营业时间
                      contactPerson: '', //联系人姓名
                      contactPhone: '', //联系人电话
                      remarks: '', //备注
                      userId: '', //工厂管理
                      maxClothes: '', //最大衣服洗护量
                      maxShoe: '', //最大鞋子洗护量
                      maxLeather: '', //最大皮革护理量
                      maxRepair: '', //最大衣鞋改补量
                };
                this.getWashcloudFactoryList();
            },
            closeDialog() {
                this.showDialog = false
                this.washcloudFactory = {
                      id: '', //
                      factoryName: '', //工厂名称
                      factoryLogo: '', //工厂LOGO
                      provinceId: '', //省
                      cityId: '', //市
                      areaId: '', //区
                      factoryAddress: '', //详细地址
                      factoryPosition: '', //定位
                      longitude: '', //经度
                      latitude: '', //纬度
                    openHours: ['08:00:00', '20:00:00'], //营业时间
                      contactPerson: '', //联系人姓名
                      contactPhone: '', //联系人电话
                      remarks: '', //备注
                      userId: '', //工厂管理
                      maxClothes: '', //最大衣服洗护量
                      maxShoe: '', //最大鞋子洗护量
                      maxLeather: '', //最大皮革护理量
                      maxRepair: '', //最大衣鞋改补量
                };
            },
            submitForm() {
                if (this.washcloudFactoryState == 'add') {
                    this.$refs.washcloudFactoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            this.washcloudFactory.openHours = this.washcloudFactory.openHours.join('-');
                            post(`/washcloud/factory/add`,{ ...this.washcloudFactory }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetWashcloudFactoryList();
                                    this.resetDialog();
                                } else {
                                    this.washcloudFactory.openHours = this.washcloudFactory.openHours.split('-');
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.washcloudFactoryState == 'edit') {
                    this.$refs.washcloudFactoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            let params = { ...this.washcloudFactory };
                            delete params.user;
                            delete params.area;
                            delete params.city;
                            delete params.province;
                            params.openHours = params.openHours.join('-');
                            post(`/washcloud/factory/edit`,{ ...params }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetWashcloudFactoryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addWashcloudFactory() {
                this.showDialog = true;
                this.washcloudFactoryState = 'add';
            },
            checkWashcloudFactory(washcloudFactoryId) {
                console.log(washcloudFactoryId);
                this.currentWashcloudFactoryId = washcloudFactoryId;

                this.getWashcloudFactoryById();
                this.showDialog = true;
                this.washcloudFactoryState = 'check';
            },
            editWashcloudFactory(washcloudFactoryId) {
                console.log('washcloudFactory', washcloudFactoryId);
                if (washcloudFactoryId) {
                    this.currentWashcloudFactoryId = washcloudFactoryId;
                    this.getWashcloudFactoryById();
                } else {
                    this.washcloudFactory = { ...this.washcloudFactory, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.washcloudFactoryState = 'edit';
            },
            deleteWashcloudFactory(washcloudFactoryId) {
                let ids = '';
                if (washcloudFactoryId) {
                    ids = washcloudFactoryId;
                } else {
                    ids = this.multipleSelection.map((washcloudFactory) => washcloudFactory.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/washcloud/factory/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetWashcloudFactoryList();
                                this.getWashcloudFactoryList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshWashcloudFactoryList() {
                this.resetWashcloudFactoryList();
                this.getWashcloudFactoryList();
            },
            getWashcloudFactoryList(query = {}) {
                this.loading = true;
                get(`/washcloud/factory/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.washcloudFactoryList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getWashcloudFactoryById() {
                get(`/washcloud/factory/get`,{ id: this.currentWashcloudFactoryId }).then((res) =>{
                    if(res.success){
                      this.washcloudFactory = { ...this.washcloudFactory, ...res.washcloudFactory };
                      this.washcloudFactory.openHours = this.washcloudFactory.openHours.split('-');
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportWashcloudFactoryList() {
                //this.btnLoading = true;
                exprotExcel(`/washcloud/factory/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/washcloud/factory/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/washcloud/factory/importData`,formData);
              this.refreshWashcloudFactoryList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getWashcloudFactoryList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getWashcloudFactoryList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>